import { motion } from 'framer-motion'
import React from 'react'

interface ConfettiPieceProps {
    color: string
    initialX: number
    initialY: number
    delay: number
}

const ConfettiPiece: React.FC<ConfettiPieceProps> = ({
    color,
    initialX,
    initialY,
    delay
}) => (
    <motion.div
        className={`absolute w-2 h-2 ${color}`}
        style={{
            left: initialX,
            top: initialY,
            borderRadius: Math.random() > 0.5 ? '50%' : '0'
        }}
        initial={{ scale: 0, opacity: 0 }}
        animate={{
            y: [0, -100 * Math.random() - 50],
            x: [0, (Math.random() - 0.5) * 200],
            rotate: [0, Math.random() * 360 * (Math.random() > 0.5 ? 1 : -1)],
            scale: [0, 1, 1, 0.5, 0],
            opacity: [0, 1, 1, 0.5, 0]
        }}
        transition={{
            duration: 2.5 + Math.random(),
            delay: delay,
            ease: 'easeOut',
            times: [0, 0.2, 0.5, 0.8, 1]
        }}
    />
)

interface ConfettiAnimationProps {
    isVisible: boolean
}

export const ConfettiAnimation: React.FC<ConfettiAnimationProps> = ({
    isVisible
}) => {
    const colors = [
        'bg-primary',
        'bg-success',
        'bg-warning',
        'bg-secondary',
        'bg-danger'
    ]

    // Generate confetti pieces for each corner and bottom
    const generateConfetti = (): ConfettiPieceProps[] => {
        const pieces = []
        const corners = [
            { x: 0, y: 0 }, // Top left
            { x: window.innerWidth, y: 0 }, // Top right
            { x: 0, y: window.innerHeight }, // Bottom left
            { x: window.innerWidth, y: window.innerHeight } // Bottom right
        ]

        // Add confetti from corners
        corners.forEach((corner) => {
            for (let i = 0; i < 15; i++) {
                pieces.push({
                    color: colors[Math.floor(Math.random() * colors.length)],
                    initialX: corner.x,
                    initialY: corner.y,
                    delay: Math.random() * 0.5
                })
            }
        })

        // Add confetti from bottom
        for (let i = 0; i < 30; i++) {
            pieces.push({
                color: colors[Math.floor(Math.random() * colors.length)],
                initialX: Math.random() * window.innerWidth,
                initialY: window.innerHeight,
                delay: Math.random() * 0.5
            })
        }

        return pieces
    }

    return (
        <div className="fixed inset-0 pointer-events-none z-50">
            {isVisible &&
                generateConfetti().map((piece, index) => (
                    <ConfettiPiece
                        key={index}
                        color={piece.color}
                        initialX={piece.initialX}
                        initialY={piece.initialY}
                        delay={piece.delay}
                    />
                ))}
        </div>
    )
}
